@if (assessment(); as definedAssessment) {
	<div class="contentContainer">
		<sim-assessment-exam-info-header
			class="header"
			[studentName]="participantDisplay().fullName"
			[studentEmail]="participantDisplay().user.email"
			[hasClinicalVignette]="clinicalVignetteText()?.length !== 0"
			(onShowClinicalVignette)="showClinicalVignette()"
		>
			@let remainingTime = remainingTimeClinicalVignette();
			@if (remainingTime !== null) {
				<div class="activityIndicator" [@zoomOutOnLeave]>
					<div class="activityType">
						<mat-icon class="secondary" fontIcon="fa-stopwatch" fontSet="fad" inline />
					</div>
					<div class="info">
						<span class="secondary">{{ T.EXAMINER_ASSESSMENT_DISPLAY_READING_CLINICAL_VIGNETTE | translate }} </span>
						<span class="time">{{ remainingTime * 1000 | durationLabel }}</span>
					</div>
				</div>
			}
		</sim-assessment-exam-info-header>

		<sim-exam-device-panel class="left">
			<h2 header>{{ T.EXAMINER_ASSESSMENT_DISPLAY_ASSESSMENT_INDEX_TITLE | translate }}</h2>

			@if (assessmentPanel().isFormInitialized()) {
				<sim-assessment-exam-index
					content
					[assessment]="assessmentPanel().$changedAssessment | async"
					[activeItemId]="assessmentPanel().itemExpanded()"
					[activeGroupId]="assessmentPanel().groupExpanded()"
					(onGroupClicked)="onIndexGroupClicked($event)"
					(onItemClicked)="onIndexItemClicked($event)"
				/>
			}
		</sim-exam-device-panel>

		<sim-exam-device-panel class="center">
			<h1 header class="mat-h2">{{ definedAssessment.name }}</h1>
			<div content>
				<p class="introductoryItemTitlePrefix">
					{{ definedAssessment.introductoryItemTitlePrefix }}
				</p>
				<sim-assessment-answer-panel
					class="assessment"
					[variant]="AssessmentAnswerPanelVariant.ExaminerView"
					[mode]="definedAssessment.state === AssessmentState.InProgress ? AssessablePanelMode.Answer : AssessablePanelMode.View"
					[assessable]="definedAssessment"
				/>
			</div>
		</sim-exam-device-panel>

		<div class="right">
			<sim-exam-device-panel>
				<h2 header>Comments</h2>

				@if (assessmentPanel().isFormInitialized()) {
					<sim-assessment-examiner-note
						content
						[mode]="
							definedAssessment.state === AssessmentState.InProgress ? AssessablePanelMode.Answer : AssessablePanelMode.View
						"
						[note]="assessmentPanel().note"
						(noteChange)="assessmentPanel().handleNoteChange($event)"
					/>
				}
			</sim-exam-device-panel>

			<div class="examinerActions">
				<sim-button
					class="full-width-btn"
					(onClick)="abortAssessment(definedAssessment)"
					[disabled]="definedAssessment.state !== AssessmentState.InProgress"
					[icon]="{
						fontSet: 'fas',
						fontIcon: 'fa-times',
					}"
					[label]="T.ASSESSMENT_PANE_ABORT_BUTTON"
					color="warn"
				/>
			</div>
		</div>
	</div>
}
